import * as React from "react";
import { Link, navigate } from "gatsby";
import "../../gatsby-browser.js";
import Navbar from "../component/Navbar/Navbar";
import Footer from "../component/Footer/Footer";
import { motion } from "framer-motion";
import MetaTags from "../component/MetaTags.jsx";
import ContactForm from "../component/Courses/ContactForm.js";

import CourseDefaultBanner from "../static/img/courses-bottom-background.jpg";
import LevelUpIcon from "../static/img/icons/level-up.png";
import HourglassIcon from "../static/img/icons/hourglass.png";

import Price from "../component/Price.jsx";
import JapaneseCourseCard from "../component/JapaneseCourseCard/JapaneseCourseCard.jsx";
import GermanCourseCard from "../component/GermanCourseCard/GermanCourseCard.jsx";
import FrenchCourseCard from "../component/FrenchCourseCard/FrenchCourseCard.jsx";

import coursePrices from "../data/coursePrices.json";

class AllCourses extends React.Component {
  scrollToContact = () => {
    document
      .getElementById("courses-sec")
      ?.scrollIntoView({ behavior: "smooth" });
  };

  render() {
    const pageVariants = {
      initial: { opacity: 0 },
      in: { opacity: 1 },
      out: { opacity: 0 },
    };

    return (
      <>
        <Navbar />
        <h1 className="highlighted-text" align="center" style={{ marginTop: "6rem" }}>
          All Courses at Koderbox
        </h1>
        <FrenchCourseCard buyNow={true} />
        <GermanCourseCard buyNow={true} />
        <JapaneseCourseCard buyNow={true} />

          <Footer />

        <MetaTags
          title="All Courses | Online Coding & Language Classes | Koderbox"
          description="Explore all Koderbox courses including Japanese, French, German, and Coding programs with live instructors and flexible batches."
          path="/all-courses/"
        />
      </>
    );
  }
}

export default AllCourses;

/* ========= REUSABLE COURSE CARD ========= */

const CourseCard = ({ title, desc, points, link, price, onBuy }) => (
  <div className="col-lg-6 col-md-12 mb-5">
    <div className="courses__course-box h-100">
      <div
        className="course-box__head"
        style={{
          backgroundImage: `url(${CourseDefaultBanner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="course-box__content d-flex flex-column">
        <div className="course-box__content--meta">
          <div>
            <img src={LevelUpIcon} alt="level" /> Intermediate
          </div>
          <div>
            <img src={HourglassIcon} alt="duration" /> 6 weeks
          </div>
        </div>

        <h3>{title}</h3>
        <p>{desc}</p>
        <ul>
          {points.map((p, i) => (
            <li key={i}>{p}</li>
          ))}
        </ul>

        <Price originalPrice inr={price.inr} usd={price.usd} />

        <div className="btn-container d-flex gap-3 mt-auto">
          <Link to={link}>
            <button className="btn btn-outline-primary">
              View Details
            </button>
          </Link>
          <button className="btn btn-primary" onClick={onBuy}>
            Buy Now
          </button>
        </div>
      </div>
    </div>
  </div>
);
